var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7338 0.243675C14.4089 -0.081225 13.8822 -0.081225 13.5573 0.243675L7.48873 6.31222L1.42022 0.243675C1.09533 -0.081225 0.568567 -0.081225 0.243675 0.243675C-0.081225 0.568567 -0.081225 1.09533 0.243675 1.42022L6.31219 7.48876L0.243692 13.5572C-0.0812084 13.8822 -0.0812084 14.4089 0.243692 14.7339C0.568584 15.0587 1.09535 15.0587 1.42024 14.7339L7.48873 8.6653L13.5573 14.7339C13.8822 15.0587 14.4089 15.0587 14.7338 14.7339C15.0587 14.4089 15.0587 13.8822 14.7338 13.5573L8.66527 7.48876L14.7338 1.42022C15.0587 1.09533 15.0587 0.568567 14.7338 0.243675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.7559a2eeef7f803c84105ab91a6552ba.svg";
export { ForwardRef as ReactComponent };